import {
  CheckBoxOption, ConditionForm,
  ConfigurationInfo, GiveStatusType,
  KeywordType,
  NoticeBoxContent, PeriodType,
  SelectBoxOption,
  TabMenuInfo,
  TabType,
} from '@/types/promotion';
import {
  GetFreeGiftConditionMallConfigResponse,
  GetFreeGiftConditionSearchRequest, OptionsStocksParams,
  PutFreeGiftConditionMallConfigMallNoRequest,
} from 'supporter';
import { CONFIGURATION_TYPE, GIVE_STATUS_TYPE, KEYWORD_TYPE, PERIOD_TYPE, TAB_TYPE } from '@/const/promotion';
import { OptionData, ValueType } from '@/types';
import { addMonth, getToday } from '@/utils/dateUtils';
export const i18nFreeGift = (word: string, onlyText = false, data = null): string => onlyText ? `PROMOTION_FREE_GIFT_${word}` : window.$t(`PROMOTION_FREE_GIFT_${word}`, data).toString()

// 정적 정보 시작 //
// 사은품관리 탭 메뉴
export const tabMenus: TabMenuInfo<TabType>[] = [
  {
    type: TAB_TYPE.CONFIGURATION,
    label: i18nFreeGift('CONFIGURATION', true),
    to: '/promotion/free-gift/configuration',
  },
  {
    type: TAB_TYPE.CONDITION,
    label: i18nFreeGift('GIVING_CONDITION', true),
    to: '/promotion/free-gift/condition'
  },
];

// 레이어팝업 정보
export const layerPopupInfo = {
  [TAB_TYPE.CONFIGURATION]: {
    id: CONFIGURATION_TYPE.DUPLICATED_AVAILABLE,
    title: i18nFreeGift('HELP_DUPLICATED_AVAILABLE', true)
  }
}

// 셀렉트박스, 체크박스 옵션
const optionConvertor = <O extends ValueType>(option, onlyText = false): OptionData<O>[] => Object.values(option).map((o: O): OptionData<O> => ({ name: i18nFreeGift(`${o}`, onlyText), value: o }))
export const freeGiftSelectBoxOption: SelectBoxOption = {
  usable: [
    {
      name: 'USABLE_Y',
      value: true,
    },
    {
      name: 'USABLE_N',
      value: false,
    }
  ],
  duplicatedAvailable: [
    {
      name: 'ALLOWABLE_Y',
      value: true,
    },
    {
      name: 'ALLOWABLE_N',
      value: false,
    }
  ],
  keyword: optionConvertor<KeywordType>(KEYWORD_TYPE, true),
  period: optionConvertor<PeriodType>(PERIOD_TYPE, true),
};

export const freeGiftCheckBoxOption: CheckBoxOption = {
  giveStatusType: optionConvertor<GiveStatusType>(GIVE_STATUS_TYPE, true)
}

// 안내박스 정보
export const noticeContent: NoticeBoxContent = {
  configuration: {
    notice: [
      'CONFIGURATION_NOTICE_1',
      'CONFIGURATION_NOTICE_2',
      'CONFIGURATION_NOTICE_3',
      'CONFIGURATION_NOTICE_4'
    ],
    help: [
      'CONFIGURATION_HELP_1',
      'CONFIGURATION_HELP_2',
      'CONFIGURATION_HELP_3',
      'CONFIGURATION_HELP_4'
    ],
  }
}

// 정적 정보 끝 //

// data fetching
export const putConfigurationRequestCreator = (defaultValue: GetFreeGiftConditionMallConfigResponse, { mallNo, key, value }: ConfigurationInfo): PutFreeGiftConditionMallConfigMallNoRequest => ({
  pathParams: {
    mallNo: Number(mallNo),
  },
  params: {
    ...defaultValue,
    [key]: value
  }
})

// 사은품 지급조건 관리 동적 정보 시작 //

export const today = getToday();

// 사은품 지급조건 관리 검색 초기 데이터
export const conditionForm = (): ConditionForm => {
  return {
    mallNo: undefined,
    keywordType: KEYWORD_TYPE.CONDITION_NAME,
    keyword: '',
    periodType: PERIOD_TYPE.REGISTER_AT,
    startDateTime: addMonth(today, -3),
    endDateTime: today,
    giveStatusType: Object.values(GIVE_STATUS_TYPE),
    page: 1,
    size: 30,
  }
}

// 사은품 지급조건 관리 검색 유효성 검사
export const isValidSearchForm = (conditionForm: ConditionForm, selectedCheckTypes: GiveStatusType[]): boolean => {
  if (!selectedCheckTypes.length) {
    alert(i18nFreeGift('ALERT_GIVE_STATUS_TYPE'));
    return false
  }
  return true;
};

// 사은품 지급조건 관리 검색 요청 항목 변환
export const convertSearchFomToRequest = (conditionForm: ConditionForm, selectedCheckTypes: GiveStatusType[], mallNosToString: string): GetFreeGiftConditionSearchRequest => {
  const { mallNo, keywordType, keyword, periodType, startDateTime, endDateTime, ...rest } = conditionForm;
  
  return {
    params: {
      ...rest,
      mallNos: mallNo?.toString() ?? mallNosToString,
      'keywordInfo.keywordType': keyword ? keywordType : null,
      'keywordInfo.keyword': keyword,
      'periodCondition.periodType': periodType,
      'periodCondition.startDateTime': `${startDateTime} 00:00:00`,
      'periodCondition.endDateTime': `${endDateTime} 23:59:59`,
      giveStatusType: selectedCheckTypes.join(','),
    }
  }
}

// 사은품 지급조건 관리 동적 정보 끝 //


export const generateOptionsStocksQuery = ({ mallNo, keyword }: {mallNo: number, keyword: string}): OptionsStocksParams => ({
  mallNos: mallNo.toString(),
  categoryType: 'DISPLAY_CATEGORY',
  periodType: 'REGISTER_YMDT',
  platformDisplayType: 'NONE',
  saleStatusTypes: 'ON_PRE_SALE,ON_SALE',
  saleSettingStatusTypes: 'AVAILABLE_FOR_SALE',
  searchKeywordType: 'MALL_OPTION_NO',
  keyword,
  page: 1,
  size: 5,
})
